import React, { useEffect, useState, useCallback } from "react";
import { browserName, browserVersion } from "react-device-detect";
import { useNavigate } from "react-router";
import Popup from "../components/Popup";
import { getPlanProfile, getSlots, savePlan } from "../services/apiServices";
import { logEvent } from "../services/apiServices.js";
import { isEmpty } from "../validators/helper.js";
import addImg from "./../components/images/add.svg";
import CreateSlot from "./CreateSlot";
import { MDBInputGroup, MDBCheckbox, MDBBtn, MDBIcon, MDBBadge } from "mdb-react-ui-kit";
import PageError from "./PageError";
import { useAnalytics } from "../hooks/useAnalytics";

const VaritationPlan = ({ onBack, data, parentData, ...props }) => {
    const { trackButtonClick } = useAnalytics();
    const [apiError, setApiError] = useState(false);
    const [form, setForm] = useState({
        description: "",
    });
    const [subPlans, setSubPlans] = useState([]);
    const [oldPlanId, setOldPlanId] = useState("");
    const [membershipname, setMembershipName] = useState("");
    const [error, setError] = useState({});
    const navigate = useNavigate();
    const [slot, setSlots] = useState([]);
    const [selslots, setSelSlots] = useState([]);
    const [weekday, setWeekDay] = useState([]);
    const [openAddSlot, setOpenAddSlot] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Create default subplan function
    const createDefaultSubPlan = useCallback(() => ({
        id: Date.now(),
        name: "",
        validity: "",
        validtype: "1",
        sessioncheck: false,
        sessionvalue: "",
        sessionsharinglimit: "",
        ptype: "",
        discount: "0",
        price: "",
        taxcheck: false,
        validtimetype: false,
        enable: true,
        forcetrainer: false,
        autocheckin: false,
        description: "",
        memberenable: false,
        globalplan: false,
        freeguestpasses: "",
        newmembersonly: true

    }), []);

    useEffect(() => {


        async function fetchSData() {
            if (localStorage.getItem("loggedUserInfo")) {
                try {
                    const response = await getSlots(
                        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                    );
                    console.log(response);
                    if (!response) {
                        return;
                    }
                    if (response === "false") {
                        setApiError(true);
                        return;
                    }
                    const record = await response.json();
                    if (!record) {
                        navigate("/");
                        return;
                    }
                    setSlots(record);
                    console.log(record);

                    // Default to selecting all slots if none are pre-selected
                    if (parentData?.pslots?.length > 0) {
                        setSelSlots(parentData.pslots);
                    } else if (data?.pslots?.length > 0) {
                        setSelSlots(data.pslots);
                    } else {
                        setSelSlots(record); // Select all slots by default
                    }
                } catch (error) {
                    console.error("Error fetching slots:", error);
                    setApiError(true);
                }
            }
        }

        fetchSData();
    }, [navigate, parentData, data]);

    useEffect(() => {
        const initializeData = () => {
            if (parentData && parentData._id) {

                setMembershipName(parentData.name || "");
                setForm({ description: parentData.description || "" });

                if (parentData.pslots && Array.isArray(parentData.pslots)) {
                    setSelSlots(parentData.pslots);
                }

                // Default to all days if none are selected
                if (parentData.pdays && Array.isArray(parentData.pdays) && parentData.pdays.length > 0) {
                    setWeekDay(parentData.pdays);
                } else {
                    setWeekDay([{ day: 1 }, { day: 2 }, { day: 3 }, { day: 4 }, { day: 5 }, { day: 6 }, { day: 7 }]);
                }

                if (parentData.subplans && Array.isArray(parentData.subplans)) {
                    const initializedSubplans = parentData.subplans.map((subplan) => ({
                        ...subplan,
                        id: subplan.id || Date.now(),
                        sessioncheck: subplan.sessioncheck || false,
                        sessionvalue: subplan.sessionvalue || "",
                        sessionsharinglimit: subplan.sessionsharinglimit || "",
                        validity: subplan.numberofdays || subplan.validity || "1",
                        validtype: subplan.validityflag || "1",
                        ptype: subplan.ptype?.toString() || "1",
                        discount: subplan.discount || "0",
                        taxcheck: subplan.taxcheck !== undefined ? subplan.taxcheck : true,
                        validtimetype: subplan.validtimetype || false,
                        enable: subplan.enable !== undefined ? subplan.enable : true,
                        forcetrainer: subplan.forcetrainer || false,
                        autocheckin: subplan.autocheckin || false,
                        description: subplan.description || "",
                        memberenable: subplan.memberenable || false,
                        globalplan: subplan.globalplan || false,
                        freeguestpasses: subplan.freeguestpasses || "",
                        newmembersonly: subplan.newmembersonly || true,


                    }));
                    setSubPlans(initializedSubplans);
                } else {
                    setSubPlans([createDefaultSubPlan()]);
                }
            } else if (data) {

                if (typeof data === "object" && !Array.isArray(data)) {
                    const oldplan = data._id;
                    setOldPlanId(oldplan);
                    setMembershipName(data.name || "");
                    setForm({ description: data.description || "" });
                    const { _id, ...rest } = data;

                    const subplanWithEmptyName = {
                        ...rest,
                        name: "",
                        oldplanid: oldplan,
                        taxcheck: rest.taxcheck !== undefined ? rest.taxcheck : true,
                    };

                    setSubPlans([subplanWithEmptyName]);

                    // Set default days if not provided
                    if (!rest.pdays || rest.pdays.length === 0) {
                        setWeekDay([{ day: 1 }, { day: 2 }, { day: 3 }, { day: 4 }, { day: 5 }, { day: 6 }, { day: 7 }]);
                    } else {
                        setWeekDay(rest.pdays);
                    }
                } else if (Array.isArray(data)) {
                    setSubPlans(data);
                    setMembershipName("");
                    setWeekDay([{ day: 1 }, { day: 2 }, { day: 3 }, { day: 4 }, { day: 5 }, { day: 6 }, { day: 7 }]);
                }
            } else {
                setSubPlans([createDefaultSubPlan()]);
                setMembershipName("");
                setWeekDay([{ day: 1 }, { day: 2 }, { day: 3 }, { day: 4 }, { day: 5 }, { day: 6 }, { day: 7 }]);
            }
        };

        initializeData();
    }, [data, parentData, createDefaultSubPlan]);

    function addNewSlots(e) {
        setOpenAddSlot(true);
    }

    function closePopup() {
        setOpenAddSlot(false);
    }

    function updateSlot(item) {
        console.log(item);
        setSlots([...slot, item]);
        setSelSlots([...selslots, item]);
        closePopup();
    }

    function handleDays(e, value) {
        let ischecked = weekday && weekday.length > 0 && weekday.filter((item) => item.day === value).length > 0;

        if (!ischecked) {
            if (!weekday || weekday.length === 0) {
                setWeekDay([{ day: value }]);
            } else {
                setWeekDay([...weekday, { day: value }]);
            }
        } else {
            const nWeekdays = weekday.filter((item) => item.day !== value);
            setWeekDay(nWeekdays);
        }
    }

    function handleSlots(e, titem) {
        let ischecked = selslots && selslots.length > 0 && selslots.filter((item) => item._id === titem._id).length > 0;

        console.log(ischecked);
        if (!ischecked) {
            if (!selslots || selslots.length === 0) {
                setSelSlots([{ _id: titem._id }]);
            } else {
                setSelSlots([...selslots, { _id: titem._id }]);
            }
        } else {
            if (!selslots || selslots.length === 0) {
                const nselslots = [{ _id: titem._id }];
                setSelSlots(nselslots);
            } else {
                const nselslots = selslots.filter((item) => item._id !== titem._id);
                setSelSlots(nselslots);
            }
        }
    }

    const handleAddSubPlan = () => {
        const newSubPlan = {
            id: Date.now(),
            name: "",
            validity: "",
            validtype: "1",
            sessioncheck: false,
            sessionvalue: "",
            sessionsharinglimit: "",
            ptype: "",
            discount: "0",
            price: "",
            taxcheck: true,
            validtimetype: false,
            enable: true,
            forcetrainer: false,
            autocheckin: false,
            description: "",
        };

        setSubPlans((prev) => [...prev, newSubPlan]);
    };

    const handleFormChange = (index, field, value) => {
        setSubPlans((prevSubPlans) => {
            const updated = [...prevSubPlans];
            if (index < 0 || index >= updated.length) return prevSubPlans;
            updated[index] = {
                ...updated[index],
                [field]: value,
            };
            return updated;
        });
    };



    const validateForm = useCallback(() => {
        let errors = {};

        if (isEmpty(membershipname)) {
            errors.membershipname = "Membership Name can't be blank";
        }

        if (weekday.length === 0) {
            errors.weekday = "Please select at least one valid day";
        }

        if (selslots.length === 0) {
            errors.selslots = "Please select at least one slot";
        }

        subPlans.forEach((subPlan, index) => {
            if (isEmpty(subPlan.name)) {
                errors[`subPlanName_${index}`] = `name can't be blank`;
            }
            if (isEmpty(subPlan.validity)) {
                errors[`subPlanValidity_${index}`] = `validity can't be blank`;
            }
            if (isEmpty(subPlan.price)) {
                errors[`subPlanPrice_${index}`] = `price can't be blank`;
            }
            if (!subPlan.ptype) {
                errors[`subPlanPtype_${index}`] = `please select a plan type`;
            }
            if (subPlan.sessioncheck && isEmpty(subPlan.sessionvalue)) {
                errors[`subPlanSessionValue_${index}`] = `session value can't be blank`;
            }
            if (subPlan.sessioncheck && !isEmpty(subPlan.sessionvalue) && !isEmpty(subPlan.sessionsharinglimit) && Number(subPlan.sessionsharinglimit) > Number(subPlan.sessionvalue)) {
                errors[`subPlanSessionSharingLimit_${index}`] = `Session Sharing Limit cannot be greater than Session Limit`;
            }
        });

        console.log(errors);
        return Object.keys(errors).length === 0 ? true : errors;
    }, [membershipname, weekday, selslots, subPlans]);

    async function onSubmit(e) {
        e.preventDefault();
        const errors = validateForm();

        if (errors === true) {
            setIsSubmitting(true);
            const mergedSubPlans = subPlans.map((plan) => ({
                ...plan,
                pslots: selslots,
                pdays: weekday,
            }));

            const updates = {
                name: membershipname,
                slots: selslots,
                days: weekday,
                description: form.description,
                _id: parentData?._id && parentData._id !== -1 ? parentData._id : null,
                oldplanid: oldPlanId,
                subplans: mergedSubPlans,
                isVariation: true,
                globalplan: mergedSubPlans.some(s => s.globalplan === true),
            };

            console.log("updates", updates);

            try {
                let savedObj = await savePlan(
                    updates,
                    localStorage.getItem("loggedUserInfo")
                        ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                        : ""
                );
                if (savedObj === "false") {
                    setApiError(true);
                    setIsSubmitting(false);
                    return;
                }
                let plan = await savedObj.json();
                console.log(plan);
                let Eventtype = "plan";
                let gymid = localStorage.getItem("loggedUserInfo")
                    ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                    : "";
                let username1 = localStorage.getItem("loggedUserInfo")
                    ? JSON.parse(localStorage.getItem("loggedUserInfo")).email
                    : "";
                let ip = localStorage.getItem("ipaddress");
                let browserinfo = browserName + "-" + browserVersion + ".0.0";
                if (props.id === plan._id) {
                    let flag = `Plan Updated Successfull (${updates.name})`;

                    await trackButtonClick("VaritationPlan", "Update_Plan", "staff", {});
                    logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
                    console.log("Plan Created Successfull2222");
                    props.onsubmit(plan);
                } else {
                    let flag = `Varitation plan Created Successfull (${updates.name})`;
                    await trackButtonClick("VaritationPlan", "Create_Plan", "staff", {});

                    logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
                    localStorage.setItem("setting_save_plan", "Plan saved successfully");
                    props.onsubmit(plan);
                }
                navigate("/plansandaddons");

            } catch (error) {
                console.error("Error saving plan:", error);
                setApiError(true);
            } finally {
                setIsSubmitting(false);
            }
        } else {
            setError(errors);
        }
    }

    const handleReload = () => {
        window.location.reload();
    };

    const handleRemoveSubPlan = (idOrIndex) => {
        if (subPlans.length <= 1) {
            alert("You must have at least one variation plan");
            return;
        }
        setSubPlans((prev) =>
            prev.filter((sub) => (sub.id || prev.indexOf(sub)) !== idOrIndex)
        );
    };

    let plansInfo = localStorage.getItem("planInfo")
        ? JSON.parse(localStorage.getItem("planInfo"))
        : null;
    let slotValue = true;
    if (
        plansInfo != null &&
        plansInfo.planFeature?.timeslots &&
        plansInfo.planLimitation?.timeslots != -1 &&
        plansInfo.planLimitation?.timeslots <= slot.length
    ) {
        slotValue = false;
    }

    return (
        <>
            {apiError ? (
                <PageError handleReload={handleReload} />
            ) : (
                <>
                    {!props.viewmode && (
                        <>
                            <div className="gym-container px-0 flex-grow-1">
                                <form
                                    action="#"
                                    target="_blank"
                                    onSubmit={onSubmit}
                                    className="business-form form-height"
                                >
                                    <div className="d-flex flex-column h-100">
                                        <div className="flex-grow-1 overflow-auto">

                                            <div>


                                                <div className="col-6 d-flex align-items-center ">
                                                    <label style={{ whiteSpace: "nowrap" }} className="me-2">
                                                        Membership Name<span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="gym-input"
                                                        type="text"
                                                        name="name"
                                                        id="name"
                                                        placeholder="Plan Name"
                                                        value={membershipname}
                                                        onChange={(e) => setMembershipName(e.target.value)}
                                                    />

                                                </div>


                                                {error.membershipname && (
                                                    <p className="clr-red error-text">{error.membershipname}</p>
                                                )}
                                            </div>

                                            <div className="gym-section">
                                                <label className="text-start w-100">Valid Days:</label>
                                                {error.weekday && (
                                                    <p className="clr-red">{error.weekday}</p>
                                                )}
                                                <div className="allowedslotsall">
                                                    {[1, 2, 3, 4, 5, 6, 7].map(day => (
                                                        <div
                                                            key={day}
                                                            className={
                                                                weekday &&
                                                                    weekday.length > 0 &&
                                                                    weekday.filter((item) => item.day === day).length > 0
                                                                    ? "slot-datepactive"
                                                                    : "slot-datep"
                                                            }
                                                        >
                                                            <div>
                                                                <div
                                                                    className="d-flex"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={(e) => handleDays(e, day)}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        className="gym-input w-inherit"
                                                                        checked={
                                                                            weekday &&
                                                                            weekday.length > 0 &&
                                                                            weekday.filter((item) => item.day === day)
                                                                                .length > 0
                                                                        }
                                                                        onChange={(e) => handleDays(e, day)}
                                                                    />
                                                                    &nbsp;{['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'][day - 1]}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {plansInfo != null && plansInfo?.feature?.timeslots && (
                                                <div className="gym-section">
                                                    <div>
                                                        <div className="slot-img">
                                                            <span>Allowed Slots:</span>
                                                            {slotValue ? (
                                                                <img
                                                                    src={addImg}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={(event) => addNewSlots(event)}
                                                                    alt="Add Slots"
                                                                />
                                                            ) : (
                                                                ""
                                                            )}
                                                            {error.selslots && (
                                                                <>
                                                                    <p className="clr-red">{error.selslots}</p>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="allowedslotsall">
                                                            {slot.length > 0 && (
                                                                <>
                                                                    {slot.map((item) => (
                                                                        <div
                                                                            key={item._id}
                                                                            className={
                                                                                selslots &&
                                                                                    selslots.length > 0 &&
                                                                                    selslots.filter(
                                                                                        (titem) => titem._id === item._id
                                                                                    ).length > 0
                                                                                    ? "allowedslotsmain-boxactive"
                                                                                    : "allowedslotsmain-box"
                                                                            }
                                                                        >
                                                                            <div
                                                                                className="allowedslot-box"
                                                                                onClick={(e) => handleSlots(e, item)}
                                                                            >
                                                                                <div>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="gym-input"
                                                                                        checked={
                                                                                            selslots &&
                                                                                            selslots.length > 0 &&
                                                                                            selslots.filter(
                                                                                                (titem) => titem._id === item._id
                                                                                            ).length > 0
                                                                                        }
                                                                                        onChange={(e) => handleSlots(e, item)}
                                                                                    />
                                                                                </div>
                                                                                <div className="slottime">
                                                                                    <span>{item.name}</span>
                                                                                    <span>
                                                                                        {item.shrs} :
                                                                                        {item.smins === "1"
                                                                                            ? "00"
                                                                                            : item.smins === "2"
                                                                                                ? "15"
                                                                                                : item.smins === "3"
                                                                                                    ? "30"
                                                                                                    : "45"}{" "}
                                                                                        {item.shflag === "1" ? "AM" : "PM"} to{" "}
                                                                                        {item.ehrs} :
                                                                                        {item.emins === "1"
                                                                                            ? "00"
                                                                                            : item.emins === "2"
                                                                                                ? "15"
                                                                                                : item.emins === "3"
                                                                                                    ? "30"
                                                                                                    : "45"}{" "}
                                                                                        {item.ehflag === "1" ? "AM" : "PM"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            )}
                                                            {slot.length <= 0 && (
                                                                <>
                                                                    <div> No slots created yet</div>
                                                                    <br />
                                                                    <br />
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                <h6 className="text-dark m-0">Variations</h6>
                                                <MDBBtn type="button" onClick={handleAddSubPlan}>
                                                    <MDBIcon fas icon="plus" /> Add Varitation Plan
                                                </MDBBtn>

                                            </div>

                                            {subPlans.map((subPlan, index) => (
                                                <div
                                                    key={subPlan.id || index}
                                                    className="p-2 border rounded-4 border-1 mb-3 shadow-2-strong"
                                                >

                                                    {!subPlan?._id && subPlans.length > 1 && (
                                                        <div className="text-end mt-2">
                                                            <MDBBtn
                                                                color="danger"
                                                                size="sm"
                                                                onClick={() => handleRemoveSubPlan(subPlan.id || index)}
                                                            >
                                                                <MDBIcon fas icon="trash" />
                                                            </MDBBtn>
                                                        </div>
                                                    )}

                                                    <div className="slot-foot row">
                                                        <div className="col-4 gym-section gym-half">
                                                            <label>
                                                                Plan Name:<span className="text-danger">*</span>
                                                            </label>
                                                            <MDBInputGroup className="plan-input-group">
                                                                <span className="plan-badge">
                                                                    {membershipname}
                                                                </span>
                                                                <input
                                                                    className="plan-input"
                                                                    type="text"
                                                                    placeholder="e.g., Weekly"
                                                                    value={subPlan.name}
                                                                    onChange={(e) => handleFormChange(index, "name", e.target.value)}
                                                                />
                                                            </MDBInputGroup>
                                                            {error[`subPlanName_${index}`] && (
                                                                <p className="clr-red">{error[`subPlanName_${index}`]}</p>
                                                            )}
                                                        </div>

                                                        <div className="col-4 gym-section gym-half">
                                                            <label>
                                                                Validity:<span className="text-danger">*</span>
                                                            </label>
                                                            <MDBInputGroup>
                                                                <input
                                                                    className="gym-input w-40"
                                                                    type="number"
                                                                    maxLength={2}
                                                                    placeholder="30"
                                                                    value={subPlan.validity}
                                                                    onChange={(e) =>
                                                                        handleFormChange(
                                                                            index,
                                                                            "validity",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                                <select
                                                                    className="gym-input w-50"
                                                                    value={subPlan.validtype}
                                                                    onChange={(e) =>
                                                                        handleFormChange(
                                                                            index,
                                                                            "validtype",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="1">Day(s)</option>
                                                                    <option value="2">Month(s)</option>
                                                                    <option value="3">Year(s)</option>
                                                                </select>
                                                            </MDBInputGroup>
                                                            {error[`subPlanValidity_${index}`] && (
                                                                <p className="clr-red">
                                                                    {error[`subPlanValidity_${index}`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                        <div className=" col-4 gym-section gym-half">
                                                            <label>Plan Type:<span className="text-danger">*</span></label>
                                                            <select
                                                                className="gym-input"
                                                                value={subPlan.ptype || subPlan.type}
                                                                onChange={(e) =>
                                                                    handleFormChange(index, "ptype", e.target.value)
                                                                }
                                                            >
                                                                <option value="" disabled>Select Plan Type</option>
                                                                <option value="1">One-time</option>
                                                                <option value="2">Recurring</option>
                                                            </select>
                                                            {error[`subPlanPtype_${index}`] && (
                                                                <p className="clr-red">{error[`subPlanPtype_${index}`]}</p>
                                                            )}
                                                        </div>
                                                        <div className="col-12 row gym-section">

                                                            <div className="col-4 gym-section gym-half">
                                                                <label>Allowed Discount:</label>
                                                                <select
                                                                    className="gym-input"
                                                                    value={subPlan.discount}
                                                                    onChange={(e) =>
                                                                        handleFormChange(
                                                                            index,
                                                                            "discount",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="0">0%</option>
                                                                    <option value="1">5%</option>
                                                                    <option value="2">10%</option>
                                                                    <option value="3">15%</option>
                                                                    <option value="4">50%</option>
                                                                    <option value="5">100%</option>
                                                                </select>
                                                            </div>

                                                            <div className=" col-4 gym-section gym-half">
                                                                <label>
                                                                    Plan Price:<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="gym-input"
                                                                    type="text"
                                                                    placeholder="Price"
                                                                    value={subPlan.price}
                                                                    onChange={(e) =>
                                                                        handleFormChange(index, "price", e.target.value)
                                                                    }
                                                                />
                                                                {error[`subPlanPrice_${index}`] && (
                                                                    <p className="clr-red">
                                                                        {error[`subPlanPrice_${index}`]}
                                                                    </p>
                                                                )}
                                                                <p className="d-flex align-items-center mt-2 mb-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={subPlan.taxcheck}
                                                                        onChange={() =>
                                                                            handleFormChange(
                                                                                index,
                                                                                "taxcheck",
                                                                                !subPlan.taxcheck
                                                                            )
                                                                        }
                                                                    />
                                                                    <label className="ms-2">Include Tax</label>
                                                                </p>
                                                            </div>








                                                        </div>

                                                        <div className="col-12 my-0 row gym-section">
                                                            <div className="col-4 m-0 gym-section">
                                                                <MDBCheckbox
                                                                    name="sessioncheck"
                                                                    checked={subPlan.sessioncheck}
                                                                    label="Session Limit"
                                                                    onChange={() =>
                                                                        handleFormChange(
                                                                            index,
                                                                            "sessioncheck",
                                                                            !subPlan.sessioncheck
                                                                        )
                                                                    }
                                                                />
                                                                {subPlan.sessioncheck && (
                                                                    <input
                                                                        className="gym-input"
                                                                        type="number"
                                                                        placeholder="30"
                                                                        value={subPlan.sessionvalue}
                                                                        onChange={(e) =>
                                                                            handleFormChange(
                                                                                index,
                                                                                "sessionvalue",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                                {error[`subPlanSessionValue_${index}`] && (
                                                                    <p className="clr-red">
                                                                        {error[`subPlanSessionValue_${index}`]}
                                                                    </p>
                                                                )}
                                                            </div>

                                                            {subPlan.sessioncheck && (
                                                                <>
                                                                    <div className="col-4 m-0 d-block gym-section align-self-end">
                                                                        <label>Session Sharing Limit:</label>
                                                                        <input
                                                                            className="gym-input"
                                                                            type="number"
                                                                            name="sessionsharinglimit"
                                                                            id="sessionsharinglimit"
                                                                            placeholder="Session Sharing Limit"
                                                                            value={subPlan.sessionsharinglimit}
                                                                            onChange={(e) =>
                                                                                handleFormChange(
                                                                                    index,
                                                                                    "sessionsharinglimit",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        />
                                                                        {error[`subPlanSessionSharingLimit_${index}`] && (
                                                                            <p className="clr-red">
                                                                                {error[`subPlanSessionSharingLimit_${index}`]}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>

                                                    </div>




                                                    <div className="slot-foot row my-2">

                                                        <div className="col-md-3 gym-section gym-half d-flex flex-row align-items-center my-0">
                                                            <label className="mb-0 switchlabel">
                                                                Enable/Disable Plan:
                                                            </label>
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={subPlan.enable}
                                                                    onChange={() =>
                                                                        handleFormChange(
                                                                            index,
                                                                            "enable",
                                                                            !subPlan.enable
                                                                        )
                                                                    }
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </div>


                                                        <div className="col-md-3 gym-section gym-half d-flex flex-row align-items-center my-0">
                                                            <label className="mb-0 switchlabel">
                                                                Force Trainer at Check-in:{" "}
                                                            </label>
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={subPlan.forcetrainer}
                                                                    onChange={() => {
                                                                        // If enabling force trainer, disable auto check-in
                                                                        handleFormChange(index, "forcetrainer", !subPlan.forcetrainer);
                                                                        if (!subPlan.forcetrainer) {
                                                                            handleFormChange(index, "autocheckin", false);
                                                                        }
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-3 gym-section gym-half d-flex flex-row align-items-center my-0">
                                                            <label className="mb-0 switchlabel">
                                                                Auto Check-in:{" "}
                                                            </label>
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={subPlan.autocheckin}
                                                                    onChange={() => {
                                                                        // If enabling auto check-in, disable force trainer
                                                                        handleFormChange(index, "autocheckin", !subPlan.autocheckin);
                                                                        if (!subPlan.autocheckin) {
                                                                            handleFormChange(index, "forcetrainer", false);
                                                                        }
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-3 gym-section gym-half">
                                                            <div className="d-flex align-items-center">
                                                                <label className="switchlabel mb-0">
                                                                    24 Hours:
                                                                </label>
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={subPlan.validtimetype}
                                                                        onChange={() =>
                                                                            handleFormChange(
                                                                                index,
                                                                                "validtimetype",
                                                                                !subPlan.validtimetype
                                                                            )
                                                                        }
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                        </div>


                                                        <div className="col-md-3 gym-section gym-half d-flex flex-row align-items-center my-0">
                                                            <label className="mb-0 switchlabel">Enable in Member Portal:</label>
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={subPlan.memberenable || false}
                                                                    onChange={() =>
                                                                        handleFormChange(
                                                                            index,
                                                                            "memberenable",
                                                                            !subPlan.memberenable
                                                                        )
                                                                    }
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </div>

                                                        <div className="col-md-3 gym-section gym-half d-flex flex-row align-items-center my-0">
                                                            <label className="mb-0 switchlabel">Global plan</label>
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={subPlan.globalplan || false}
                                                                    onChange={() =>
                                                                        handleFormChange(
                                                                            index,
                                                                            "globalplan",
                                                                            !subPlan.globalplan
                                                                        )
                                                                    }
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 gym-section gym-half"></div>

                                                        <div className="col-md-4  gym-half  ms-0 my-2 py-2   ms-md-3 my-md-2 py-md-2 border border-1 rounded bg-light">
                                                            <div className="d-flex align-items-center">
                                                                <label className="w-50">
                                                                    Guest Passes:
                                                                </label>
                                                                <div className="ms-4 flex-grow-1">
                                                                    <input
                                                                        className="form-control"
                                                                        type="number"
                                                                        name={`freeguestpasses_${index}`}
                                                                        id={`freeguestpasses_${index}`}
                                                                        placeholder="Enter Guest Passes"
                                                                        value={subPlan.freeguestpasses || ""}
                                                                        // min="0"
                                                                        // max="99"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (value === "" || (Number(value) >= 0 && Number(value) <= 99)) {
                                                                                handleFormChange(index, "freeguestpasses", value);
                                                                            }
                                                                        }}
                                                                        onWheel={(e) => e.preventDefault()}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="d-flex justify-content-between  mt-2 flex-row align-items-center my-0">
                                                                <label className="mb-0 switchlabel">New Members</label>
                                                                <label className="switch">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={subPlan.newmembersonly || false}
                                                                        onChange={(e) => handleFormChange(index, "newmembersonly", !subPlan.newmembersonly)}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                        </div>






                                                    </div>


                                                </div>


                                            ))}

                                            <div className="w-100 mt-1">
                                                <label className="switchlabel">Description: </label>
                                                <textarea
                                                    className="p-2 w-100 textarea"
                                                    id="form6Example7"
                                                    label=""
                                                    rows="5"
                                                    placeholder="Describe about this Plan here..."
                                                    name="description"
                                                    maxLength={1024}
                                                    value={form.description || ""}
                                                    onChange={(e) =>
                                                        setForm({ ...form, description: e.target.value })
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3 mt-3 d-flex justify-content-between">
                                            <div>
                                                {!parentData && (
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if (subPlans.length > 0) {
                                                                const firstSubplan = subPlans[0];
                                                                const backData = {
                                                                    ...firstSubplan,
                                                                    _id: firstSubplan.oldplanid || undefined,
                                                                    name: membershipname,
                                                                    globalplan: subPlans.some(s => s.globalplan === true)
                                                                };
                                                                onBack(backData);
                                                            } else {
                                                                onBack(null);
                                                            }
                                                        }}
                                                        className="btn btn-secondary"
                                                    >
                                                        Back to Create Plan
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    type="button"
                                                    onClick={props.onclose}
                                                    className="btn btn-secondary"
                                                    data-mdb-dismiss="modal"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            &nbsp;
                                            <button
                                                type="submit"
                                                className="btn btn-primary me-2"
                                                disabled={isSubmitting}
                                                data-mdb-dismiss="modal"
                                            >
                                                {isSubmitting ? "Saving..." : "Save"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            {(plansInfo === null ||
                                (plansInfo?.feature && plansInfo?.feature?.timeslots)) && (
                                    <>
                                        {openAddSlot && (
                                            <Popup
                                                title="Create/Edit Slot"
                                                ptype="modal-lg"
                                                content={
                                                    <>
                                                        <div>
                                                            <CreateSlot
                                                                ispopup="0"
                                                                onsubmit={updateSlot}
                                                                onclose={closePopup}
                                                                oncancel={closePopup}
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                handleClose={closePopup}
                                            />
                                        )}
                                    </>
                                )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default VaritationPlan;